export const SET_THEME = 'THEME'
